/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-03 18:04:42
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-11-01 16:32:02
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Table/Table.tsx
 */
import React from 'react';
import css from './GlobalTable.less';
import { Table } from 'antd';
const CustomTable = (props) => {
  const { data, pagination, columns, className, expandable, ...rest } = props;
  //console.log('expandable', expandable);
  return (
    <Table
      expandable={expandable}
      className={`${css.globalTable} ${className || ''}`}
      dataSource={data}
      columns={columns}
      pagination={pagination}
      {...rest}
    />
  );
};
export default CustomTable;
